import React from 'react';
import NumericButton from './NumericButton';

const NumericButtonsGroup = (props) => {
    const { radio } = props;

    return (
        <div className='col-8 mt-5 p-0'>
            <div className="row ml-4 mt-3">
                <NumericButton value={1} radio={radio} />
                <NumericButton value={2} radio={radio} />
                <NumericButton value={3} radio={radio} />
            </div>
            <div className="row ml-3 mt-2">
                <NumericButton value={4} radio={radio} />
                <NumericButton value={5} radio={radio} />
                <NumericButton value={6} radio={radio} />
            </div>
            <div className="row ml-2 mt-2">
                <NumericButton value={7} radio={radio} />
                <NumericButton value={8} radio={radio} />
                <NumericButton value={9} radio={radio} />
            </div>
            <div className="row ml-1 mt-2">
                <div className="col-sm-2 m-1"></div>
                <NumericButton value={0} radio={radio} />
                <div className="col-sm-2 m-1"></div>
            </div>
        </div>
    );
};

export default NumericButtonsGroup;
